<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bUwXKT/tc-custom/9780544186590.jpg?1729185276639" alt="This image is the cover for the book Gluten-Free Girl Every Day"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gluten-Free Girl Every Day
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The James Beard Award–winning, approachable cookbook for home cooks making gluten-free</b> <b>dinner for their families.</b></p><p>Shauna Ahern, the author of <i>Gluten-Free Girl and the Chef</i>—named by the <i>New York Times</i> as one of the best cookbooks of 2010—returns with a new cookbook for busy people who still love to cook. It features food you want to cook every day: fresh, satisfying, and filled with great flavors. The inspired ingredient pairings of these recipes come from the collaboration of Ahern and her husband Danny, a professional chef.</p><p>Vegetables in season are the key to these healthy, relatively simple recipes, along with whole grains, beans, and a few key spices and homemade sauces. Also included are practical tips on how to stock a gluten-free pantry, as well as helpful insights into how to bake gluten-free. </p>Features 120 gluten-free recipes for weeknight dinners and desserts Includes suggestions for foods that can be made ahead or frozen to make dinnertime easier ·Organized around different types of dinners: Breakfast for Dinner, One-Pot Wonders, Stir Fries, and Breaking Down a Chicken, for example.<p>All the recipes in <i>Gluten-Free Girl Every Day</i> are gluten-free, and many are dairy-free or vegetarian as well. However, the only thing that truly matters is that these dishes are delicious.</p><p><b>“The pictures will pull you into the kitchen and Shauna’s recipes will keep you there. I love her bold combinations…and their everyday simplicity. That the dishes are gluten-free is the bonus; that they'll please everyone is the gift.”—Dorie Greenspan, author of <i>Around My French Table</i> and owner of Beurre &amp; Sel Cookies</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shauna James Ahern, Daniel Ahern, Penny De Los Santos
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33d12db7